module.exports = __webpack_public_path__ + "static/media/area.7aec79f6.svg";